import { Component, VNode } from "vue";

import type { InputIconPosition, InputVariant } from "./ui";
import { type Placement } from "@popperjs/core";

export interface IOptions {
  label: string;
  value: string;
}

export interface TooltipProps {
  labelIcon?: string | object | (() => VNode) | null;
  text: string;
  maxWidth?: string;
  bgColor: string;
  color: string;
  placement?: Placement;
}

export interface IFormField {
  name: string;
  label?: string;
  labelIcon?: Component | string | object | (() => VNode) | null;
  type: string;
  required?: boolean;
  placeholder?: string;
  variant?: InputVariant;
  cols?: number;
  rows?: number;
  options?: IOptions[];
  maxlength?: string;
  minlength?: string;
  min?: string;
  max?: string;
  disabled?: boolean;
  icon?: Component | null;
  iconPosition?: InputIconPosition;
  testId?: string;
  prefix?: string;
  suffix?: string;
  autofocus?: boolean;
  outerSuffix?: string;
  onKeypress?: (event: KeyboardEvent) => void;
  onPaste?: (event: ClipboardEvent) => void;
  onFocus?: (event: FocusEvent) => void;
  readonly?: boolean;
  loading?: boolean;
  loadingText?: string;
  loadingOptions?: boolean;
  loadingMoreOptions?: boolean;
  labelTooltip?: TooltipProps;
  hint?: {
    text: string;
    type?: 'success' | 'info' | 'error';
  } | null;
}

export interface IStates {
  state: string;
  city: string[];
}

export interface IAccountSetupStatus {
  setUpStep?: string | number | null;
  SetUpStep?: string | number | null;
  step1Completed?: boolean;
  Step1Completed?: boolean;
  step2Completed?: boolean;
  Step2Completed?: boolean;
  step3Completed?: boolean;
  Step3Completed?: boolean;
  setUpCompleted?: boolean;
  SetUpCompleted?: boolean;
  workspaceReady?: boolean;
  WorkspaceReady?: boolean;
}

export enum GlobalStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Deactivated',
  SHUTDOWN = 'Shutdown',
}

export interface ListMember {
  id: string;
  email: string;
  firstname?: string;
  lastname?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
}